import React, { useState, useEffect, useContext } from 'react';
import { Spinner, Container } from 'reactstrap';
import PracticeNewCard from '../Card/PracticeNewCard';
import { Hub } from 'aws-amplify';
import { UserContext } from '../../components/UserContext'
import Lottie from 'react-lottie';
import { default as animationData } from '../../assets/loader.json';
import { cx } from '@emotion/css';
import * as styles from '../welcome/welcome.style';
import * as assignmentStyles from '../assignments/assignments.style';
import premiumHeroImg from '../../assets/gen_images/challenges_hero.png';
import revImg from '../../assets/gen_images/rev.png';
import { useHistory } from 'react-router-dom';
import { SubscriptionContext } from '../../reducers/SubscriptionContext';

function PremCatScreen(props) {
  const history = useHistory();
  const { user } = useContext(UserContext);
  const { subscriptionStatus } = useContext(SubscriptionContext);
  const [isPremium, setIsPremium] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [premiumCheckError, setPremiumCheckError] = useState(null);
  const [events_category, set_events_category] = useState([]);
  const [loadedcategories, set_loadedcategories] = useState(false);

  useEffect(() => {
    const checkPremiumAccess = async () => {
      try {
        if (subscriptionStatus !== null) {
          const isPremiumUser = subscriptionStatus === "active" || (user && user.premiumuser === 1);
          setIsPremium(isPremiumUser);
          
          if (isPremiumUser && user && Object.keys(user).length > 0) {
            set_events_category([
              { 
                "id": 2, 
                "category": "MISTAKESREVIEW", 
                "title": "Revision", 
                "count": 1, 
                "username": user.username, 
                "totalquestions": 20, 
                "time": 400, 
                "grade": user.grade, 
                "premiumlevel": user.premiumuser 
              },
            ]);
            set_loadedcategories(true);
          }
          if (user && Object.keys(user).length > 0) {
            setIsLoading(false);
          }
        }
      } catch (error) {
        console.error('Error checking premium status:', error);
        setPremiumCheckError('Failed to verify subscription status');
        setIsLoading(false);
      }
    };
    checkPremiumAccess();
  }, [subscriptionStatus, user]);

  useEffect(() => {
    const authListener = Hub.listen('auth', ({ payload: { event } }) => {
      if (event === 'signOut') {
        history.push('/');
      }
    });
    return () => Hub.remove('auth', authListener);
  }, [history]);

  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: { preserveAspectRatio: 'xMidYMid slice' }
  };

  if (isLoading && (!user || Object.keys(user).length === 0)) {
    return (
      <div className={cx(styles.pageWrapper)} style={{ paddingTop: '100px' }}>
        <div className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
          <Spinner color="primary" style={{ width: '3rem', height: '3rem' }} />
          <p className="mt-3">Initializing your session...</p>
        </div>
      </div>
    );
  }

  if (premiumCheckError) {
    return (
      <div className={cx(styles.pageWrapper)} style={{ paddingTop: '100px' }}>
        <div className="container mt-5 text-center">
          <div className="alert alert-warning">
            <h4>Access Issue</h4>
            <p className="mb-3">{premiumCheckError}</p>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>Retry</button>
          </div>
        </div>
      </div>
    );
  }

  if (!isPremium && !isLoading) {
    return (
      <div className={cx(styles.pageWrapper)} style={{ paddingTop: '100px' }}>
        <div className="container mt-5 text-center">
          <div className="alert alert-warning">
            <h3>Premium Access Required</h3>
            <p className="mb-4">This section requires an active premium subscription.</p>
            <button className="btn btn-primary" onClick={() => window.location.href = '/subscription'}>Upgrade to Premium</button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={cx(styles.pageWrapper)}>


      <Container>
        <h2 className={cx(assignmentStyles.sectionHeading)} style={{ textAlign: 'center', marginBottom: '3rem' }}>
          Your Premium Challenges
        </h2>
        
        {loadedcategories ? (
          <div className={cx(assignmentStyles.challengeGrid)}>
            {events_category.map(eventcategory => {
              let target = "premiumquiz";
              if (eventcategory.category === 'HyphenSpaceChallenge') {
                target = 'hyphen-space-challenge';
              } else if (eventcategory.category === 'UppercaseChallenge') {
                target = 'uppercase-challenge';
              }

              return (
                <PracticeNewCard
                  key={eventcategory.id}
                  title={eventcategory.title || eventcategory.category}
                  eventcategory={eventcategory}
                  premiumlevel={user.premiumuser}
                  target={target}
                  customImg={revImg}
                />
              );
            })}
          </div>
        ) : (
          <div className="text-center py-5">
            <Lottie options={defaultOptions} height={200} width={200} />
            <p className="mt-3">Loading premium modules...</p>
          </div>
        )}
      </Container>
    </div>
  );
}

export default PremCatScreen;